import React from "react";
import WordCardDetailsState, { WordCardDetailsProps } from "./WordCardDetails.models";
import wordCardImage from '../../assest/images/card-image/wordCard.png'
import successReadingImage from '../../assest/images/card-image/successReading.png'
import './WordCardDetails.scss';
import LearningBoxCardService from "../../services/content/LearningBoxCardService";
import { NavLink } from "react-router-dom";
import FlashCardBookmark from "../../services/content/FlashCardBookmark";

export default class WordCardDetails extends React.PureComponent<WordCardDetailsProps, WordCardDetailsState>{
    learningBoxCardService: LearningBoxCardService;
    flashCardBookmark: FlashCardBookmark;
    constructor(props: WordCardDetailsProps) {
        super(props);
        this.flashCardBookmark = new FlashCardBookmark()
        this.learningBoxCardService = new LearningBoxCardService();
        this.state = { boxId: '', wordCards: [], selectedCard: 1, showMean: false };
    }

    componentDidMount = () => {
        if (this.props.boxId !== null && this.props.boxId !== undefined) {
            this.setState({ boxId: this.props.boxId });
            this.getPaged();
        }
    }

    componentDidUpdate = (prevProps: WordCardDetailsProps) => {
        if (prevProps.boxId !== this.props.boxId && this.props.boxId !== null && this.props.boxId !== undefined) {
            this.setState({ boxId: this.props.boxId });
            this.getPaged();
        }
    }

    getPaged = () => {
        let state = this;
        // this.learningBoxCardService.getPaged({ boxId: this.props.boxId as string }).then(response => {
        //     state.setState({ wordCards: response });
        // })

        this.learningBoxCardService.getTodayFlashCardsById(this.props.boxId as string).then(response => {
            state.setState({ wordCards: response });
        })
    }

    create = (isLearned: boolean) => {
        let state = this;
        var card = this.state.wordCards[this.state.selectedCard - 1];
        this.learningBoxCardService.create({ boxCardId: card.boxCardId, boxId: this.state.boxId, isLearned: isLearned, wordId: card.wordCardId }).then(response => {
            state.setState({ selectedCard: this.state.selectedCard + 1, showMean: false });
        })
    }

    addBookmark = () => {
        var card = this.state.wordCards[this.state.selectedCard - 1];
        this.flashCardBookmark.create(this.props.boxId as string, card.wordCardId).then(response => {
        });
    }

    render(): React.ReactNode {
        let { config } = this.props;
        let showContent = this.state.wordCards.length === 0 || this.state.wordCards.length < this.state.selectedCard ? false : true;
        let content;
        if (showContent) {
            content = <>
                <div className="col-12">
                    {
                        this.state.wordCards.map((word, key) => {
                            let show = key + 1;
                            if (show === this.state.selectedCard)
                                return <div key={key}>
                                    <label className="card-title">
                                        {word.word}
                                    </label>
                                    {this.titleValueView("معنی", word.mean, this.state.showMean)}
                                    {this.titleValueView("تعریف", word.definition, this.state.showMean)}
                                </div>
                            else return <></>
                        })
                    }
                </div>



                {this.footerView(config.showActions, this.state.showMean)}
            </>;
        }
        else {
            content = <>
                <div className="leitner-back-section">
                    <label className="title">واژه های امروز تمام شدند</label>
                    <label className="sub-title">تبریک! شما واژه های امروز را مطالعه کردید</label>
                </div>

                <NavLink to={"/LeitnerBox?boxId=" + this.state.boxId} className="col-md-12 col-12 col-lg-4 tk-custom-padding" >
                    <div className="image-box">
                        <label>
                            بازگشت
                        </label>
                    </div>
                </NavLink>
            </>;
        }
        return <>
            <div className="col-12 word-card-details-area p-0">
                <div className="tk-card pb-4 px-2">
                    <div className="word-card-image pb-3">
                        <img src={showContent ? wordCardImage : successReadingImage} alt="pencil icon " />
                    </div>
                    {content}
                </div>
            </div>
        </>
    }

    titleValueView(title: string, value: string, show: boolean) {
        let content;
        if (show) {
            content =
                <div className="word-card-title-value-view-area">
                    <label className="title">
                        {title}
                    </label>
                    <label className="value">
                        {value}
                    </label>
                </div>
        }
        else content = <></>
        return <>
            {content}
        </>
    }

    footerView(showButtons: boolean, show: boolean) {
        let buttons;
        let content;
        if (show) {
            content =
                <>

                </>
        }
        else content = <>
            <div className="show-mean text-center">
                <button className="btn btn-outline-secondary" onClick={() => this.setState({ showMean: true })}>نمایش معنی</button>
            </div>
        </>

        if (showButtons)
            buttons = <>
                {content}
                <div className="word-card-footer-area text-center">
                    <button className="btn btn-primary" onClick={() => this.create(true)}>یادگرفتم</button>
                    <button className="btn btn-outline-secondary mark-icon mr-3" onClick={this.addBookmark}>
                        <i className="mdi mdi-bookmark-plus-outline"></i>
                    </button>
                    <button className="btn btn-outline-secondary mr-3" onClick={() => this.create(false)}>کنار میذارم</button>
                </div>
            </>
        else
            buttons = <></>;

        return <>
            {buttons}
        </>
    }
}